import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Accueil } from "./pages/Accueil";
import { ServicePage } from "./pages/ServicePage";
import { FormationPage } from "./pages/FormationPage";
import { ServicesPage } from "./pages/ServicesPage";
import { FormationsPage } from "./pages/FormationsPage";
import { PageIntrouvable } from "./pages/PageIntrouvable";

/** Routes du site, partagées par le navigateur et le pré-rendu. */
export const AppRoutes = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Accueil />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:slug" element={<ServicePage />} />
      <Route path="/formations" element={<FormationsPage />} />
      <Route path="/formations/:slug" element={<FormationPage />} />
      <Route path="*" element={<PageIntrouvable />} />
    </Route>
  </Routes>
);
